import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";

const InfoIcon = ({ text }) => (
  <OverlayTrigger
    placement="top"
    overlay={<Tooltip className="text-start">{text}</Tooltip>}
  >
    <span className="ms-1 text-muted cursor-pointer">
      <FaInfoCircle size={14} />
    </span>
  </OverlayTrigger>
);

export default InfoIcon;